import { useContext } from 'react';
import { I18nContext } from './I18nProvider';
import type { I18n } from './I18nProvider';

export function useI18n(): I18n {
  const value = useContext(I18nContext);
  if (value === null) {
    throw new Error('useI18n() used outside <I18nProvider>');
  }
  return value;
}
